import { render, staticRenderFns } from "./CalendarEventModal.vue?vue&type=template&id=6c2916e5"
import script from "./CalendarEventModal.vue?vue&type=script&lang=js"
export * from "./CalendarEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports